import { ActionReducer, Action, State } from '@ngrx/store'
import { EnrolmentsStore } from "@store/enrolment"
import { Enrolment } from "@models/enrolment"
import { MatrixClass } from "@models/matrix-class"
import { Contact } from "@models/contact"

export const enrolmentsReducer: ActionReducer<EnrolmentsStore> = (state: EnrolmentsStore = new EnrolmentsStore(), action: Action) => {
  switch(action.type) {
    case POPULATE_ENROLMENTS:
      return new EnrolmentsStore(
        action.payload,
        [...state.potentialClasses],
        state.selectedClass,
        state.selectedContact,
        state.editableEnrolment,
        [...state.enrolmentsToRollover])

    case POPULATE_EDITABLE_ENROLMENT:
      return new EnrolmentsStore(
        [...state.enrolments],
        [...state.potentialClasses],
        state.selectedClass,
        state.selectedContact,
        action.payload,
        [...state.enrolmentsToRollover])

    case POPULATE_POTENTIAL_CLASSES:
      return new EnrolmentsStore(
        [...state.enrolments],
        action.payload,
        state.selectedClass,
        state.selectedContact,
        state.editableEnrolment,
        [...state.enrolmentsToRollover])

    case POPULATE_SELECTED_CLASS:
      return new EnrolmentsStore(
        [...state.enrolments],
        [...state.potentialClasses],
        action.payload,
        state.selectedContact,
        state.editableEnrolment,
        [...state.enrolmentsToRollover])

    case POPULATE_ENROLMENT_SELECTED_CONTACT:
      return new EnrolmentsStore(
        [...state.enrolments],
        [...state.potentialClasses],
        state.selectedClass,
        action.payload,
        state.editableEnrolment,
        [...state.enrolmentsToRollover])


    case POPULATE_ENROLMENTS_TO_ROLLOVER:
      return new EnrolmentsStore(
        [...state.enrolments],
        [...state.potentialClasses],
        state.selectedClass,
        state.selectedContact,
        state.editableEnrolment,
        action.payload)

    default:
      return state
  }
}

export const FETCH_ENROLMENTS = 'FETCH_ENROLMENTS'
export const POPULATE_ENROLMENTS = 'POPULATE_ENROLMENTS'
export const FETCH_ENROLMENTS_FAILURE = 'FETCH_ENROLMENTS_FAILURE'
export const ADD_ENROLMENT = "ADD_ENROLMENT"
export const POPULATE_EDITABLE_ENROLMENT = 'POPULATE_EDITABLE_ENROLMENT'
export const FETCH_POTENTIAL_CLASSES = 'FETCH_POTENTIAL_CLASSES'
export const POPULATE_POTENTIAL_CLASSES = 'POPULATE_POTENTIAL_CLASSES'
export const FETCH_POTENTIAL_CLASSES_FAILURE = 'FETCH_POTENTIAL_CLASSES_FAILURE'
export const FETCH_ENROLMENT_SELECTED_CLASS = 'FETCH_ENROLMENT_SELECTED_CLASS'
export const POPULATE_SELECTED_CLASS = 'POPULATE_SELECTED_CLASS'
export const FETCH_ENROLMENT_SELECTED_CLASS_FAILURE = 'FETCH_ENROLMENT_SELECTED_CLASS_FAILURE'
export const FETCH_ENROLMENT_SELECTED_CONTACT = 'FETCH_ENROLMENT_SELECTED_CONTACT'
export const POPULATE_ENROLMENT_SELECTED_CONTACT = 'POPULATE_ENROLMENT_SELECTED_CONTACT'
export const FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE = 'FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE'
export const CREATE_ENROLMENT = "CREATE_ENROLMENT"
export const CREATE_ENROLMENT_FAILURE = "CREATE_ENROLMENT_FAILURE"
export const FETCH_ENROLMENTS_TO_ROLLOVER = "FETCH_ENROLMENTS_TO_ROLLOVER"
export const FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE = "FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE"
export const POPULATE_ENROLMENTS_TO_ROLLOVER = "POPULATE_ENROLMENTS_TO_ROLLOVER"
export const SET_ROLLOVER = "SET_ROLLOVER"
export const SET_ROLLOVER_SUCCESS = "SET_ROLLOVER_SUCCESS"
export const SET_ROLLOVER_FAILURE = "SET_ROLLOVER_FAILURE"
export const ROLLOVER_ENROLMENTS = "ROLLOVER_ENROLMENTS"
export const ROLLOVER_ENROLMENTS_SUCCESS = "ROLLOVER_ENROLMENTS_SUCCESS"
export const ROLLOVER_ENROLMENTS_FAILURE = "ROLLOVER_ENROLMENTS_FAILURE"
export const CHANGE_CLASS_ON_ENROLMENT = "CHANGE_CLASS_ON_ENROLMENT"
export const CHANGE_CLASS_ON_ENROLMENT_SUCCESS = "CHANGE_CLASS_ON_ENROLMENT_SUCCESS"
export const CHANGE_CLASS_ON_ENROLMENT_FAILURE = "CHANGE_CLASS_ON_ENROLMENT_FAILURE"
export const PERFORM_DISENROLMENT = "PERFORM_DISENROLMENT"
export const PERFORM_DISENROLMENT_SUCCESS = "PERFORM_DISENROLMENT_SUCCESS"
export const PERFORM_DISENROLMENT_FAILURE = "PERFORM_DISENROLMENT_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/enrolments.ts